import { USER_SESSION_EXPIRED, USER_PROFILE_LOADING, USER_PROFILE_SUCCESS, USER_PROFILE_FAIL, USER_PASSWORD_SUCCESS, USER_NOTIFICATION_LOADING, USER_NOTIFICATION_SUCCESS, USER_NOTIFICATION_FAIL, USER_NOTIFICATION_UNFLAGNEW, USER_NOTIFICATION_FLAGREAD, USER_NOTIFICATION_FLAGALLREAD, USER_NOTIFICATION_LOADMORE_LOADING, USER_NOTIFICATION_LOADMORE_SUCCESS, USER_NOTIFICATION_LOADMORE_FAIL, USER_RPT_PROCESS_CLOSE, USER_RPT_PROCESS, USER_RPT_PROCESS_REMOVE, USER_RPT_PROCESS_DOWNLOADSTATUS, USER_RPT_PROCESS_STATE, USER_NOTIFICATION_GET_COUNT, USER_NOTIFICATION_RPT_CHG,
  USER_RPT_GET_COUNT, USER_MSG_GET_COUNT, USER_BCH_GET_COUNT, USER_NOTIFICATION_BCH_CHG, USER_BCH_PROCESS
} from '@/store/types'
import { formatProcess } from '@/utils/report'

export const mutations = {
  [USER_PROFILE_LOADING](state) {
    resetProfile(state)
  },
  [USER_PROFILE_SUCCESS](state, data) {
    state.profile.usrId = data.usrId
    state.profile.email = data.email
    state.profile.firstName = data.firstName
    state.profile.lastName = data.lastName
    state.profile.mobileNo = data.mobileNo
    state.profile.officeNo = data.officeNo
    state.profile.passwordExpiryDate = data.passwordExpiryDate
    state.profile.usrRefId = data.usrRefId
    state.profile.mtrQuoteStatusNotify = data.mtrQuoteStatusNotify
    state.profile.mtrQuoteStatusMail = data.mtrQuoteStatusMail
    state.profile.mtrQuotePendingNotify = data.mtrQuotePendingNotify
    state.profile.mtrQuotePendingMail = data.mtrQuotePendingMail
    state.profile.crgoQuoteStatusNotify = data.crgoQuoteStatusNotify
    state.profile.crgoQuoteStatusMail = data.crgoQuoteStatusMail
    state.profile.crgoQuotePendingNotify = data.crgoQuotePendingNotify
    state.profile.crgoQuotePendingMail = data.crgoQuotePendingMail

    state.profile.init = 1
    state.profile.initErr = []
    state.profile.menu = data.menu
  },
  [USER_PROFILE_FAIL](state, err) {
    state.profile.init = 2
    state.profile.initErr = err
  },
  [USER_PASSWORD_SUCCESS](state, data) {
    state.profile.passwordExpiryDate = data.passwordExpiryDate
  },
  [USER_SESSION_EXPIRED](state) {
    state.sessionExpired = true
  },
  [USER_NOTIFICATION_LOADING](state) {
    state.notification.init = 0
  },
  [USER_NOTIFICATION_SUCCESS](state, data) {
    state.notification.menu = data.menu
    state.notification.init = 1
    state.notification.newCount = data.newNotificationCount
    state.notification.rptJobCount = data.newRptJobCount
    state.notification.draftCount = data.newDraftCount
    state.notification.notifications = data.notifications
    state.notification.bchJobCount = data.newBchJobCount
    if (data.notifications && data.notifications.length > 0) {
      state.notification.hasNext = true
      state.notification.lastId = data.notifications[data.notifications.length - 1].id
    } else {
      state.notification.hasNext = false
      state.notification.lastId = 0
    }
  },
  [USER_NOTIFICATION_FAIL](state) {
    state.notification.init = 2
  },
  [USER_NOTIFICATION_UNFLAGNEW](state) {
    state.notification.newCount = 0
    state.notification.rptJobCount = 0
    state.notification.draftCount = 0
    state.notification.bchJobCount = 0
  },
  [USER_NOTIFICATION_FLAGREAD](state, data) {
    if (data !== null) {
      state.notification.notifications[data].read = true
    }
  },
  [USER_NOTIFICATION_FLAGALLREAD](state) {
    // Flag all as read
    state.notification.notifications.map((notification) => {
      notification.read = true
    })
  },
  [USER_NOTIFICATION_LOADMORE_LOADING](state) {
    state.notification.loadingNewNotification = true
  },
  [USER_NOTIFICATION_LOADMORE_SUCCESS](state, data) {
    // Reload the menu (the next link)
    state.notification.menu = data.menu

    if (data.notifications && data.notifications.length > 0) {
      // Append new notifications
      state.notification.notifications.push.apply(state.notification.notifications, data.notifications)
      state.notification.hasNext = true
      state.notification.lastId = data.notifications[data.notifications.length - 1].id
    } else {
      state.notification.hasNext = false
    }

    state.notification.loadingNewNotification = false
  },
  [USER_NOTIFICATION_LOADMORE_FAIL](state) {
    state.notification.loadingNewNotification = false
  },
  [USER_RPT_PROCESS_CLOSE](state) {
    // Once close, clear existing jobs inside rptProcess
    state.rptJob.rptProcess.show = false
    state.rptJob.rptProcess.processes = []
  },
  [USER_RPT_PROCESS](state, data) {
    // New process being push to client side

    // Check if the record is already on the list
    const check = state.rptJob.rptProcess.processes.filter(process => process.id === data.id)
    if (check && check.length > 0) {
      // Update the status (just change the status, errorMsg as its the only thing that can change)
      const process = check[0]
      formatProcess(process, data.statusCode)
      process.errorMsg = data.errorMsg
    } else {
      // Insert into entry
      // Status are hardcoded
      formatProcess(data, data.statusCode)
      state.rptJob.rptProcess.processes.push(data)
    }

    // Open the process Overlay
    state.rptJob.rptProcess.show = true
  },
  [USER_RPT_PROCESS_REMOVE](state, data) {
    // Remove record from process
    state.rptJob.rptProcess.processes.splice(state.rptJob.rptProcess.processes.indexOf(state.rptJob.rptProcess.processes.find(process => process.id === data)), 1)
    if (state.rptJob.rptProcess.processes.length === 0) {
      state.rptJob.rptProcess.show = false
    }
  },
  [USER_RPT_PROCESS_DOWNLOADSTATUS](state, data) {
    const { id, downloading } = data
    const process = state.rptJob.rptProcess.processes.filter(process => process.id === id)
    if (process && process.length > 0) {
      process[0].downloading = downloading
    }
  },
  [USER_RPT_PROCESS_STATE](state, data) {
    state.rptJob.rptProcess.show = data
  },
  [USER_NOTIFICATION_GET_COUNT](state, data) {
    state.notification.newCount = data.newNotificationCount
    state.notification.rptJobCount = data.newRptJobCount
    state.notification.draftCount = data.newDraftCount
    state.notification.notifications = data.notifications
    state.notification.bchJobCount = data.newBchJobCount
  },
  [USER_NOTIFICATION_RPT_CHG](state, data) {
    state.notification.rptId = data.id
    state.notification.rptStatus = data.statusCode
  },
  [USER_NOTIFICATION_BCH_CHG](state, data) {
    state.notification.bchId = data.jobId
    state.notification.bchStatus = data.jobStatus
  },
  [USER_RPT_GET_COUNT](state, data) {
    state.notification.rptJobCount = data.newRptJobCount
  },
  [USER_MSG_GET_COUNT](state, data) {
    state.notification.newCount = data.newNotificationCount
    state.notification.draftCount = data.newDraftCount
  },
  [USER_BCH_GET_COUNT](state, data) {
    state.notification.bchJobCount = data.newBchJobCount
  },
  [USER_BCH_PROCESS](state, data) {
    state.bchJob.bchProcess.processes = []
    state.bchJob.bchProcess.processes.push(data)
    if (state.bchJob.bchProcess.processes.length > 0) {
      let bchStatus = state.bchJob.bchProcess.processes[0].jobStatus
      let jobId = state.bchJob.bchProcess.processes[0].jobId
      let color = state.bchJob.bchProcess.processes[0].color
      state.bchJob.bchProcess.snackbarColor = color
      if (bchStatus === 'C') {
        state.bchJob.bchProcess.bchMsg = 'Batch job ' + jobId + ' is complete'
        state.bchJob.bchProcess.show = true
      } else if (bchStatus === 'FP') {
        state.bchJob.bchProcess.bchMsg = 'The batch has been executed with errors. Please check the error logs in the Batch Job History.'
        state.bchJob.bchProcess.show = true
      } else {
        state.bchJob.bchProcess.show = false
      }
    }
  }
}

const resetProfile = (state) => {
  // Reset the state
  state.profile.init = 0
  state.profile.initErr = []

  // User state
  state.profile.usrId = undefined
  state.profile.email = undefined
  state.profile.firstName = undefined
  state.profile.lastName = undefined
  state.profile.mobileNo = undefined
  state.profile.officeNo = undefined
  state.profile.passwordExpiryDate = undefined
  state.profile.usrRefId = undefined

  state.profile.mtrQuoteStatusNotify = undefined
  state.profile.mtrQuoteStatusMail = undefined
  state.profile.mtrQuotePendingNotify = undefined
  state.profile.mtrQuotePendingMail = undefined
  state.profile.crgoQuoteStatusNotify = undefined
  state.profile.crgoQuoteStatusMail = undefined
  state.profile.crgoQuotePendingNotify = undefined
  state.profile.crgoQuotePendingMail = undefined
}
